<template>
  <div class="chainedSelects">
    <div
      v-for="(item, i) in ques.levels"
      :key="i"
      :class="{'active': ques.answerArr[i - 1] !== undefined && range[i] && range[i].length > 0, 'chainedSelect-item': true}"
    >
      <p>{{ item.value }}</p>
      <div v-if="winWidth > 468">
        <el-select @change="idx => {handleChange(i, idx)}" v-model="ques.answerArr[i]">
          <el-option v-for="(opt, idx) in range[i]" :label="opt.value" :value="idx" :key="idx"></el-option>
        </el-select>
      </div>
      <div v-else class="el-select">
        <el-select
          v-model="ques.checkedLabel[i]"
          placeholder="请选择"
          readonly="readonly"
          autocomplete="off"
          @click.native="showCascadePicker(range[i],i)"
        ></el-select>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'chained-selects',
  data() {
    return {
      answerArr: new Array(this.ques ? this.ques.levels.length : 0),
      range: new Array(this.ques ? this.ques.levels.length : 0),
      checkedLabelArr: new Array(this.ques ? this.ques.levels.length : 0),
      tempI: 0,
      winHeight: document.getElementById('app').offsetHeight,
      winWidth: document.getElementById('app').offsetWidth
    }
  },
  created() {
    this.ques.answerArr = this.answerArr
    this.ques.checkedLabel = this.checkedLabelArr
  },
  mounted() {
    this.range.splice(0, 1, this.ques.groups)
    this.watchWindow()
  },
  props: ['ques'],
  methods: {
    watchWindow() {
      window.addEventListener('resize', () => {
        let app = document.getElementById('app')
        this.winWidth = app.offsetHeight
        this.winWidth = app.offsetWidth
      })
    },
    handleChange(i, idx) {
      this.range.splice(i + 1, 1, this.range[i][idx].children)
      this.range.fill(null, i + 2) //选中区域数组
      this.ques.answerArr.fill(undefined, i + 1) //选中区域 省市县
      this.$nextTick(() => {
        let doms =
          this.$el.querySelector('.chainedSelect-item.active input') ||
          this.$el.querySelector('.el-select input')
        let inputEles = Array.from(doms)
        let flag = inputEles.some(item => item.value == '')
        this.ques.isFinish = !flag
        this.$emit('finish')
      })
    },
    showCascadePicker(range, i) {
      this.tempI = i
      let _range = range.map(item => {
        item.text = item.value
        return item
      })
      this.picker = this.$createPicker({
        data: [_range],
        onSelect: this.selectHandle
      })
      this.picker.show()
      let pickerList = document.body.getElementsByClassName('cube-picker')
      let popperList = document.body.getElementsByClassName('el-popper')
      let timesRun = 0
      let interval = setInterval(function() {
        if (timesRun === 5) {
          clearInterval(interval)
        }
        for (let i = 0; i < popperList.length; i++) {
          popperList[i].style.display = 'none'
        }
        for (let i = 0; i < pickerList.length; i++) {
          pickerList[i].style.zIndex = 10000
        }
        timesRun += 1
      }, 80)
    },
    selectHandle(selectedVal, selectedIndex, selectedText) {
      this.ques.answerArr[this.tempI] = selectedIndex[0]
      this.ques.checkedLabel[this.tempI] = selectedText[0]
      this.handleChange(this.tempI, selectedIndex[0])
    }
  }
}
</script>
<style lang="scss" scoped>
.chainedSelect-item {
  display: none;
  &:first-child,
  &.active {
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/chainedSelects.vue